import { AppLayout } from "@/components/layout/AppLayout";

function ChevronRightIcon({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
    </svg>
  );
}

const faqItems = [
  {
    question: "Хто може отримати допомогу?",
    answer: "ОСББ, управителі багатоквартирних будинків (крім державної та комунальної форми власності) та житлово-будівельні кооперативи.",
  },
  {
    question: "Який розмір допомоги?",
    answer: "До 100 000 грн для будинків до 6 поверхів, до 200 000 грн для 7-16 поверхів, до 300 000 грн для будинків від 17 поверхів.",
  },
  {
    question: "Яке обладнання можна придбати?",
    answer: "Бензинові, дизельні, газові генератори, інвертори, акумулятори, сонячні панелі.",
  },
  {
    question: "Де відкрити рахунок?",
    answer: "Рахунок із спеціальним режимом використання необхідно відкрити в одному з банків-партнерів програми.",
  },
];

export function Help() {
  return (
    <AppLayout userRole="applicant">
      <div className="space-y-6">
        {/* Header */}
        <div>
          <h1 className="text-xl font-semibold tracking-tight">Довідка</h1>
          <p className="text-[13px] text-muted-foreground mt-0.5">
            Інформація про програму «Світлодім»
          </p>
        </div>

        {/* FAQ */}
        <div className="bg-white rounded-2xl border-[3px] border-border/50 divide-y divide-border/50">
          {faqItems.map((item, index) => (
            <details key={index} className="group">
              <summary className="flex items-center justify-between p-4 cursor-pointer text-[13px] font-medium hover:bg-muted/30 transition-colors">
                {item.question}
                <ChevronRightIcon className="h-4 w-4 text-muted-foreground transition-transform group-open:rotate-90 shrink-0 ml-2" />
              </summary>
              <p className="px-4 pb-4 text-[13px] text-muted-foreground">{item.answer}</p>
            </details>
          ))}
        </div>

        {/* Info */}
        <div className="bg-muted/30 rounded-2xl border-[3px] border-border/50 p-4">
          <p className="text-[13px] font-medium">Про програму</p>
          <p className="text-[12px] text-muted-foreground mt-1">
            Програма «Світлодім» — державна підтримка для забезпечення 
            багатоквартирних будинків незалежними джерелами енергії.
          </p>
        </div>

        {/* Footer */}
        <p className="text-xs text-muted-foreground text-center pt-4">
          © 2026, Міністерство розвитку громад та територій України
        </p>
      </div>
    </AppLayout>
  );
}

export default Help;
